import { useEffect } from 'react';
import type { LexicalEditor } from 'lexical';

import { mergeRegister } from '@lexical/utils';
import { COMMAND_PRIORITY_LOW, INSERT_PARAGRAPH_COMMAND, $getSelection } from 'lexical';

import {
  CHANGE_LIST_TYPE_COMMAND,
  INSERT_ORDERED_LIST_COMMAND,
  INSERT_UNORDERED_LIST_COMMAND,
  ListType,
} from '../../nodes/PhxListNode';
import { $handleListInsertParagraph, insertList, REMOVE_LIST_COMMAND, removeList } from '../../nodes/PhxListNode';
import { $changeListType } from '../../nodes/PhxListNode/formatList';

export function useList(editor: LexicalEditor): void {
  useEffect(() => {
    return mergeRegister(
      editor.registerCommand(
        INSERT_ORDERED_LIST_COMMAND,
        (listType: ListType = 'number') => {
          insertList(editor, listType);
          return true;
        },
        COMMAND_PRIORITY_LOW
      ),
      editor.registerCommand(
        CHANGE_LIST_TYPE_COMMAND,
        (newType: ListType) => {
          $changeListType(newType);
          return true;
        },
        COMMAND_PRIORITY_LOW
      ),

      editor.registerCommand(
        INSERT_UNORDERED_LIST_COMMAND,
        () => {
          insertList(editor, 'bullet');
          return true;
        },
        COMMAND_PRIORITY_LOW
      ),
      editor.registerCommand(
        REMOVE_LIST_COMMAND,
        () => {
          removeList(editor);
          return true;
        },
        COMMAND_PRIORITY_LOW
      ),
      editor.registerCommand(
        INSERT_PARAGRAPH_COMMAND,
        () => {
          const hasHandledInsertParagraph = $handleListInsertParagraph();

          if (hasHandledInsertParagraph) {
            return true;
          }

          return false;
        },
        COMMAND_PRIORITY_LOW
      )
    );
  }, [editor]);
}
